





























































































































































































































































































































import { Component, Watch, Emit, Vue } from 'vue-property-decorator'
/* component */
import FieldChoiceModal from '@/app/components/Common/FieldChoiceModal.vue'
/* api */
import graphItemApi from '@/app/model/api/graphItemApi'
/* module */
import Session from '@/app/module/session'
import { plantingSeason, routerPath } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    FieldChoiceModal
  }
})
export default class GraphSettingModal extends Vue {
  private isHeightAcitve: boolean = true
  private isActive:string = '1'
  private isActiveSetPoint:string = '2'
  private checkboxes: {[key: string]: string|boolean}[] = [
    { label: '積算温度', value: 'integrationTemperature', checked: true },
    { label: '草丈', value: 'growthHeight', checked: true },
    { label: '茎数', value: 'stemNumber', checked: false },
    { label: '積算降水量', value: 'soilStatus', checked: false },
    { label: 'SPAD', value: 'spad', checked: false },
    { label: '幼穂長', value: 'youngHead', checked: true }
  ]
  private selectedYear: number = 0
  private selectedSeason: string = ''
  private showMasterData: boolean = true
  private showComparisonData : boolean = false
  private defaultMasterData: any = ''
  private selectedMasterData: any = ''
  private selectedFieldName: string = ''
  private selectedPast: number = 0
  private selectedPastName: string = ''
  private showFieldChoice: boolean = false
  private masterList:{[key: string]: string|number}[] = []
  private yearList: number[] = []
  private pastData: any[] = []
  private notDataMessage: boolean = false
  private termData: any = []
  private masterData: {[key: string]: any} = {
    estimated_yield: {
      date: 0,
      harvest_date_latest: 0,
      harvest_date_earliest: 0
    },
    goal_estimated_yield: {
      date: 0,
      goal_harvest_date_latest: 0,
      goal_harvest_date_earliest: 0
    },
    graph: {},
    growth_stage: [],
    planting_date: 0
  }
  private defaultDataChange: boolean = false

  /* 現在表示されているグラフの年とシーズンを表示 */
  private get defaultDisplayYear () {
    return this.$store.state.graphState.defaultGraphYear
  }
  private get defaultDisplaySeason () {
    return this.$store.state.graphState.defaultGraphSeason
  }
  @Watch('defaultDisplayYear')
  setDisplayYear (year: string) {
    this.selectedYear = parseInt(year)
  }
  @Watch('defaultDisplaySeason')
  setDisplaySeason (season: string) {
    this.selectedSeason = season
  }

  created () {
    let fieldId = this.$route.params.field_id
    let plantingId = this.$route.params.planting_id
    this.getGraphItem(fieldId, plantingId)

    /* 表示年度リストを作成 */
    let endYear = new Date().getFullYear() + 1
    for (let i = 2019; i <= endYear; i++) {
      this.yearList.push(i)
    }
  }

  /* タブの操作 */
  private changeTab (val: string) {
    this.isActive = val

    /* 選択中のものをリセット */
    this.selectedFieldName = ''
    this.selectedPast = 0
    this.showFieldChoice = false

    if (val === '1' || val === '2') {
      this.showComparisonData = false
      this.isHeightAcitve = true
    } else {
      this.showComparisonData = true
      this.isHeightAcitve = false
    }
  }

  private defaultChange () {
    this.defaultDataChange = true
  }

  private getGraphItem (fieldId: string, plantingId: string) {
    (async () => {
      const result = await graphItemApi.getGraphItem(fieldId)

      if (result.isOk()) {
        this.masterList = result.getPayload().master_data
        this.termData = result.getPayload().past_data

        let nowYear: number = new Date().getFullYear()
        let nowSeason: string

        if ((new Date().getMonth() + 1) >= 3 && (new Date().getMonth() + 1) <= 6) {
          nowSeason = '春'
        } else if ((new Date().getMonth() + 1) >= 7 && (new Date().getMonth() + 1) <= 10) {
          nowSeason = '秋'
        } else {
          nowSeason = '冬'
        }

        // 現在の年度・シーズンではない場合のみ表示
        for (var i in this.termData.planting_period) {
          this.pastData.push(this.termData.planting_period[i])
        }

        if (this.pastData.length === 0) {
          this.notDataMessage = true
        }

        /* 現在のマスタデータ名を取得 */
        let varietyId = JSON.parse(Session.getVarietyId()!)
        for (var j in this.masterList) {
          if (this.masterList[j].id === varietyId) {
            this.selectedMasterData = this.masterList[j]
            this.defaultMasterData = this.masterList[j]
          }

          /* データ存在判定 */
          if (result.getPayload().past_data.planting_period === null) {
            this.showFieldChoice = true
          }
        }
      } else if (result.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkNotFoundStatus()) {
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkStatus()) {
        CommonClass.doLogout()
      } else {
        this.$emit('show-error-toast', result.getPayload().message)
      }
    })()
  }

  /* 選択した圃場名を表示 */
  private displaySelectedFiled (val: any) {
    this.selectedFieldName = val
    this.showFieldChoice = true
  }

  /* 項目設定処理 */
  private setGraphItem () {
    if (this.defaultDataChange) {
      this.changeDisplayYear(this.selectedYear, this.selectedSeason)
      this.defaultDataChange = false

      let checkList = []
      for (var j in this.checkboxes) {
        if (this.checkboxes[j].checked) {
          checkList.push(this.checkboxes[j])
        }
      }

      this.$emit('display-graph-item', {
        checkbox: checkList,
        year: this.selectedYear,
        season: this.selectedSeason,
        master: this.selectedMasterData.name,
        field: this.selectedFieldName,
        past: this.selectedPastName
      })
    }

    /* 比較データありなし */
    if (this.selectedFieldName === '' && this.selectedPast === 0) {
      // どちらも選択されていない＝比較無
      this.$store.commit('graphToggleState/setHiddenComparisonData', true)
    } else {
      // それ以外＝比較有り
      this.$store.commit('graphToggleState/setHiddenComparisonData', false)
    }

    /* 表示項目 */
    this.changeDisplayItem(this.checkboxes)
    this.$store.commit('graphToggleState/setCheckboxes', this.checkboxes)

    /* 比較(圃場) */
    if (this.selectedFieldName !== '') {
      let fieldList = JSON.parse(Session.getFieldData()!)

      for (var i in fieldList) {
        if (fieldList[i].fieldName === this.selectedFieldName) {
          this.comparisonField(fieldList[i].plantingId)
        }
      }
    } else {
      this.selectedFieldName = ''
      this.$store.commit('graphToggleState/setChangeComparisonGraph', true)
    }

    /* 比較(過去) */
    if (this.selectedPast !== 0) {
      this.comparisonField(String(this.selectedPast))
    } else {
      this.selectedPast = 0
      this.selectedPastName = ''
      this.$store.commit('graphToggleState/setChangeComparisonGraph', true)
    }

    /* チェックボックス */
    let checkList = []
    for (var k in this.checkboxes) {
      if (this.checkboxes[k].checked) {
        checkList.push(this.checkboxes[k])
      }
    }

    this.$emit('display-graph-item', {
      checkbox: checkList,
      year: this.selectedYear,
      season: this.selectedSeason,
      master: this.selectedMasterData.name,
      field: this.selectedFieldName,
      past: this.selectedPastName
    })

    this.$emit('close-modal')
  }

  /* 表示項目変更 */
  private changeDisplayItem (list: any) {
    /* 選択されたチェックボックス */
    let checkList = []
    for (var i in this.checkboxes) {
      if (this.checkboxes[i].checked) {
        checkList.push(this.checkboxes[i])
      }
    }
    this.$emit('update-checkboxes', list)
  }

  /* 表示年変更 */
  private changeDisplayYear (year: number, season: string) {
    for (var i in this.pastData) {
      if (this.pastData[i].season === season) {
        if (this.pastData[i].year === String(year)) {
          /* 表示年度とシーズン */
          let year = String(this.pastData[i].planting_date).slice(0, 4)
          let display = year + '年 ' + this.pastData[i].season
          this.$store.commit('fieldDetailsState/setDisplayYear', display)

          this.$emit('change-display-year', this.pastData[i].planting_id)
        }
      }
    }

    let pastList = this.pastData.filter(function (data) {
      return (data.season === season && data.year === String(year))
    })
    if (pastList.length === 0) {
      this.$emit('show-season-error')
    }

    this.$emit('close-modal')
  }

  /* 他の圃場比較 */
  private comparisonField (id: string) {
    this.$emit('add-comparison-data', { id: id, type: 'plant' })
    this.$emit('add-comparison-stage', { id: id, type: 'master' })

    /* 過去データ名 */
    for (var n in this.pastData) {
      if (this.pastData[n].planting_id === this.selectedPast) {
        let year = this.pastData[n].year + '年'
        let season = this.pastData[n].season

        this.selectedPastName = year + ' ' + season
      }
    }

    this.$emit('close-modal')
  }

  /* モーダルを閉じる */
  private closeModal () {
    // 年とシーズンをリセット
    this.selectedYear = this.$store.state.graphState.defaultGraphYear
    this.selectedSeason = this.$store.state.graphState.defaultGraphSeason

    this.$emit('close-modal')
  }

  /* 表示項目リセット */
  private resetGraphItem () {
    /* チェックボックス */
    this.checkboxes = [
      { label: '積算温度', value: 'integrationTemperature', checked: true },
      { label: '草丈', value: 'growthHeight', checked: true },
      { label: '茎数', value: 'stemNumber', checked: false },
      { label: '積算降水量', value: 'soilStatus', checked: false },
      { label: 'SPAD', value: 'spad', checked: false },
      { label: '幼穂長', value: 'youngHead', checked: true }
    ]

    /* 年 */
    this.selectedYear = this.$store.state.graphState.defaultGraphYear

    /* シーズン */
    this.selectedSeason = this.$store.state.graphState.defaultGraphSeason

    this.changeTab('1')

    this.selectedFieldName = ''
    this.showFieldChoice = false
    this.defaultDataChange = true
  }

  private displayYears (val: number) {
    let newValue = JSON.stringify(val).slice(0, 4)
    return newValue
  }

  public showErrorToast (msg: string) {
    this.$emit('show-error-toast', msg)
  }

  private removeSelected () {
    this.selectedFieldName = ''
    this.showFieldChoice = false
  }
}
